module.exports = __webpack_public_path__ + "img/42-s.3643cbcd.png";